import styled from 'styled-components';

import { system, SystemProps } from '@sternum/styled-system';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const TextArea = styled.textarea<SystemProps>`
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  border: 1px solid ${ct({ Dark: Colors.GreyDarkerMiddle, Light: Colors.GreyDarkerMiddle })};
  border-radius: 4px;
  outline: none;

  &:focus-visible,
  &:focus {
    outline: none;
  }

  &[aria-errormessage] {
    border: 1px solid ${ct({ Dark: Colors.RedMiddle, Light: Colors.RedMiddle })};
  }

  ${system}
`;
